export const ETransactionOwnerType = {
  Company: "company",
  Worker: "worker",
} as const;
export type ETransactionOwnerType =
  (typeof ETransactionOwnerType)[keyof typeof ETransactionOwnerType];
